import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { loadBranchDropdownData, loadSlocDropdownData, loadZoneMasterCategoryDropdownData, loadZoneMasterClassDropdownData, loadZoneMasterParentCodeDropdownData, postZoneMasterDatas } from "../../../redux/action";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch, useSelector } from "react-redux";
import ZoneMaster from "./ZoneMaster";
import { ADDED_BY_ID } from "../../../Constants";

const statusOptions = [
    { value: 73, label: "Active" },
    { value: 74, label: "Inactive" }
]

const AddZoneMaster = (props) => {
    let dispatch = useDispatch();
    const { getZoneClassDropdownData, getZoneCategoryDropdownData, slocDropdown, branchDropdown, getParentCodeDropdownData } = useSelector((state) => state.data);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;

    const [ZoneMasterData, setZoneMasterData] = useState({
        ZoneName: "",
        ZoneNo: "",
        Zone_CategoryID: null,
        Zone_ClassID: null,
        Branch_ID: null,
        Sloc_ID: null,
        ParentZone_ID: null,
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
        StatusID: null
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(loadZoneMasterClassDropdownData());
        dispatch(loadZoneMasterCategoryDropdownData());
        dispatch(loadBranchDropdownData());
        dispatch(loadZoneMasterParentCodeDropdownData());
    }, []);

    useEffect(() => {
        if (props.zoneID && props.getSingleZoneMasterData?.length > 0) {
            const zoneData = props.getSingleZoneMasterData[0];
            setZoneMasterData({
                Zone_ID: props.zoneID,
                ZoneName: zoneData.ZoneName || "",
                ZoneNo: zoneData.ZoneNo || "",
                Zone_CategoryID: { value: zoneData.Zone_CategoryID, label: zoneData.CategoryName },
                Zone_ClassID: { value: zoneData.Zone_ClassID, label: zoneData.ClassName },
                Branch_ID: { value: zoneData.Branch_ID, label: zoneData.BranchName },
                Sloc_ID: { value: zoneData.Sloc_ID, label: zoneData.SlocName },
                StatusID: { value: zoneData.StatusID, label: zoneData.Status },
                ParentZone_ID: zoneData.ParentZone_ID ? { value: zoneData.ParentZone_ID, label: zoneData.ParentZoneName } : null,
                CompanyID: zoneData.CompanyID,
                AddedByID: ADDED_BY_ID
            });
        }
    }, [props.zoneID, props.getSingleZoneMasterData]);

    const handleChange = (field, value) => {
        setZoneMasterData(prevState => ({ ...prevState, [field]: value }));
        if (errors[field]) {
            setErrors(prevErrors => ({ ...prevErrors, [field]: value ? "" : `required !` }));
        }
        if (field === 'Branch_ID') {
            dispatch(loadSlocDropdownData([value?.value]));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        ['ZoneName', 'ZoneNo', 'Zone_CategoryID', 'Zone_ClassID', 'Branch_ID', 'Sloc_ID'].forEach(field => {
            if (!ZoneMasterData[field]) newErrors[field] = `required !`;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddZoneMasterData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const formData = {
                ...ZoneMasterData,
                Zone_CategoryID: ZoneMasterData.Zone_CategoryID?.value,
                Zone_ClassID: ZoneMasterData.Zone_ClassID?.value,
                Branch_ID: ZoneMasterData.Branch_ID?.value,
                Sloc_ID: ZoneMasterData.Sloc_ID?.value,
                ParentZone_ID: ZoneMasterData.ParentZone_ID?.value,
                StatusID: ZoneMasterData.StatusID?.value
            };
            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(formData),
            };
            dispatch(postZoneMasterDatas(requestOption, props.handleCloseModal, props.zoneID, props.zoneMasterData));
            console.log(formData, 'ZoneMasterData')
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{props.zoneID ? "Edit Zone Master" : "Add Zone Master"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Zone Name <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={ZoneMasterData.ZoneName}
                                            onChange={(e) => handleChange('ZoneName', e.target.value)} />
                                        {errors.ZoneName && <div className="text-danger">{errors.ZoneName}</div>}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Zone Number <span className="required-asterisk">*</span></label>
                                        <Form.Control type="text" value={ZoneMasterData.ZoneNo} onChange={(e) => handleChange('ZoneNo', e.target.value)} />
                                        {errors.ZoneNo && <div className="text-danger">{errors.ZoneNo}</div>}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Zone Category <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={getZoneCategoryDropdownData}
                                            placeholder="Select"
                                            value={ZoneMasterData.Zone_CategoryID}
                                            onChange={(value) => handleChange('Zone_CategoryID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.Zone_CategoryID && <div className="text-danger">{errors.Zone_CategoryID}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Zone Class <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={getZoneClassDropdownData}
                                            placeholder="Select"
                                            value={ZoneMasterData.Zone_ClassID}
                                            onChange={(value) => handleChange('Zone_ClassID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.Zone_ClassID && <div className="text-danger">{errors.Zone_ClassID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Plant Code <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={branchDropdown}
                                            placeholder="Select"
                                            value={ZoneMasterData.Branch_ID}
                                            onChange={(value) => handleChange('Branch_ID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.Branch_ID && <div className="text-danger">{errors.Branch_ID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Sloc Code <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={slocDropdown}
                                            placeholder="Select"
                                            value={ZoneMasterData.Sloc_ID}
                                            onChange={(value) => handleChange('Sloc_ID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.Sloc_ID && <div className="text-danger">{errors.Sloc_ID}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Parent Zone</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={getParentCodeDropdownData}
                                            placeholder="Select"
                                            value={ZoneMasterData.ParentZone_ID}
                                            onChange={(value) => handleChange('ParentZone_ID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>
                                {props.zoneID && <Col md={4}>
                                    <div>
                                        <label>Status</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statusOptions}
                                            placeholder="Select"
                                            value={ZoneMasterData.StatusID}
                                            onChange={(value) => handleChange('StatusID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit"
                        onClickEffect={AddZoneMasterData}
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddZoneMaster;
